import { render, staticRenderFns } from "./WebBuild.vue?vue&type=template&id=c8424f2e&scoped=true"
import script from "./WebBuild.vue?vue&type=script&lang=js"
export * from "./WebBuild.vue?vue&type=script&lang=js"
import style0 from "./WebBuild.vue?vue&type=style&index=0&id=c8424f2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8424f2e",
  null
  
)

export default component.exports